window.initOverrideVariantSelectors = () => {
  const cardWrappers = document.querySelectorAll('.js-card-wrapper')

  if (cardWrappers) {
    cardWrappers.forEach(cardWrapper => {
      const variantSelectors = cardWrapper.querySelectorAll('.js-variant-handler')
      const productLinks = cardWrapper.querySelectorAll('.js-product-link')
      const imageVariant = cardWrapper.querySelector('.js-image-variant')
      const secondImageVariant = cardWrapper.querySelector('.js-second-image-variant')
      const itemsOnSale = cardWrapper.querySelectorAll('.item_on_sale')
      if(itemsOnSale.length > 0) {
        itemsOnSale[0].classList.add('active')
      }
      if (variantSelectors[0]) {
        const firstPriceWrapper = variantSelectors[0].parentNode.parentNode.querySelector('.js-price-sale')
        const firstVariantPrice = variantSelectors[0].getAttribute('data-variant-price')
        const firstComparePrice = variantSelectors[0].getAttribute('data-variant-compare-price')
        const firstVariantPriceSelectors = variantSelectors[0].parentNode.parentNode.querySelectorAll('.js-price-changer')
        const firstComparePriceSelector = variantSelectors[0].parentNode.parentNode.querySelector('.js-price-regular')

        if (firstComparePrice && firstPriceWrapper) {
          firstPriceWrapper.classList.add('on-sale');
        } else if (firstPriceWrapper && firstPriceWrapper.classList.contains('on-sale')) {
          firstPriceWrapper.classList.remove('on-sale');
        }

        if (firstVariantPrice && firstVariantPriceSelectors) {
          firstVariantPriceSelectors.forEach(firstVariantPriceSelector => {
            firstVariantPriceSelector.innerHTML = firstVariantPrice
          })
        }
        if (firstComparePrice && firstComparePriceSelector) {
          firstComparePriceSelector.innerHTML = firstComparePrice; 
        }
      }
      if (variantSelectors && variantSelectors.length > 0) {
        variantSelectors.forEach(variantSelector => {
          variantSelector.addEventListener('click', (e) => {
            variantSelectors.forEach(variantSelector => {
              variantSelector.classList.remove('active')
            })
            let _this = e.target
            let swatchImage = _this.getAttribute('data-variant-image')
            let swatchSecondImage = _this.getAttribute('data-variant-second-image')
            let swatchUrl = _this.getAttribute('data-variant-url')
            let variantPrice = _this.getAttribute('data-variant-price')
            let comparePrice = _this.getAttribute('data-variant-compare-price')
            const priceWrapper = _this.parentNode.parentNode.querySelector('.js-price-sale')
            const priceSelector = _this.parentNode.parentNode.querySelector('.js-price-changer')
            if (comparePrice) {
              priceWrapper.classList.add('on-sale')
            } else {
              if (priceWrapper.classList.contains('on-sale')) priceWrapper.classList.remove('on-sale')
            }
            priceSelector.innerHTML = variantPrice
            _this.classList.add('active')
            if (productLinks) {
              productLinks.forEach(productLink => {
                productLink.href = swatchUrl
              })
            }
            if (imageVariant) {
              imageVariant.srcset = swatchImage
            }
            if (secondImageVariant) {
              secondImageVariant.srcset=swatchSecondImage
            }
          })
        })
      }
    })
  }
}
window.initOverrideVariantSelectors()

let megaMenuSelectors = document.querySelectorAll('.js-megamenu')
let megaMenus = document.querySelectorAll('.js-new-mega-menu')
let headerSelector = document.querySelector('.header')
console.log(megaMenuSelectors, 'megaMenuSelector')
megaMenuSelectors.forEach(megaMenuSelector => {
  megaMenuSelector.addEventListener('mouseenter', e => {
     let _this = e.target
     _this.setAttribute('open', true)
     _this.querySelector('.header__menu-item ').setAttribute('aria-expanded', true)
     headerSelector.classList.add('meganav--visible')
     document.body.classList.add('is-megamenu-visible')
  });
  megaMenuSelector.addEventListener('mouseleave', e => {
    let _this = e.target
    _this.removeAttribute('open')
    _this.querySelector('.header__menu-item ').setAttribute('aria-expanded', false)
    headerSelector.classList.remove('meganav--visible')
    document.body.classList.remove('is-megamenu-visible')
  });
})
megaMenus.forEach(megaMenu => {
  megaMenu.addEventListener('mouseenter', e => {
     let _this = e.target
     _this.parentNode.setAttribute('open', true)
     headerSelector.classList.add('meganav--visible')
     document.body.classList.add('is-megamenu-visible')
  });
  megaMenu.addEventListener('mouseleave', e => {
    let _this = e.target
    _this.parentNode.removeAttribute('open')
    headerSelector.classList.remove('meganav--visible')
    document.body.classList.remove('is-megamenu-visible')
 });
})

let allMegaMenus = document.querySelectorAll('.js-megamenu')
document.addEventListener('keyup', e => {
  if(e.key == 'Tab') {
    let _this = e.target
    allMegaMenus.forEach(allMegaMenu => {
      allMegaMenu.removeAttribute('open')
      headerSelector.classList.remove('meganav--visible')
      document.body.classList.remove('is-megamenu-visible')
    })
    if(_this.classList.contains('js-show-megamenu')) {
      _this.parentNode.setAttribute('open', true)
     headerSelector.classList.add('meganav--visible')
     document.body.classList.add('is-megamenu-visible')
    }
    if(_this.classList.contains('mega-menu__link')) {
      _this.parentNode.parentNode.parentNode.parentNode.parentNode.setAttribute('open', true)
     headerSelector.classList.add('meganav--visible')
     document.body.classList.add('is-megamenu-visible')
    }
    if (_this.closest('.MegaMenu-Content-cards__single')) {
      _this.closest('.js-megamenu').setAttribute('open', true)
     headerSelector.classList.add('meganav--visible')
     document.body.classList.add('is-megamenu-visible')
    }
  //   let _this = e.target
  //   console.log(_this, '_this')
  //  _this.parentNode.setAttribute('open', true)
  //  headerSelector.classList.add('meganav--visible')
  // } else {
  //   let _this = e.target
  //   _this.parentNode.removeAttribute('open')
  //   headerSelector.classList.remove('meganav--visible')
  }
});
